import type * as m from "@bokio/mobile-web-shared/core/model/model";

export interface PhoneCountry {
	IsoCode2: string;
	IsoCode3: string;
	InternationalCallingCode: string;
}

export function countryResultsToPhoneCountries(
	countries: m.Bokio.Common.Contract.Internationalization.CountryResult[],
): PhoneCountry[] {
	return countries.map(c => ({
		IsoCode2: c.IsoCode2,
		IsoCode3: c.IsoCode3,
		InternationalCallingCode: c.InternationalCallingCode,
	}));
}
